import React, { useState } from 'react';
import styled from 'styled-components';
import BottomNavigation from '../customComponents/BottomNavigation';
import LoginRequiredModal from '../components/LoginRequiredModal';
import { useNavigate } from 'react-router-dom';

const LayoutContainer = styled.div<{ 
  $showBottomNav: boolean; 
  $customPaddingTop?: number;
}>`
  display: flex;
  flex-direction: column;
  min-height: ${props => props.$showBottomNav ? 'calc(100vh - 90px)' : '100vh'}; /* 바텀 네비게이션 높이 제외 */
  padding-bottom: ${props => props.$showBottomNav ? '80px' : '0'}; /* 바텀 네비게이션 높이 만큼 패딩 추가 */
  padding-top: 90px; /* 웹 앱바 높이 고정값 */

  @media (max-width: 767px) {
    min-height: ${props => props.$showBottomNav ? 'calc(100vh - 90px)' : '100vh'}; /* 바텀 네비게이션 높이 제외 */
    padding-top: ${props => props.$customPaddingTop || 0}px; /* 커스텀 패딩이 있으면 사용, 없으면 기본 60px */
  }

  @media (min-width: 768px) {
    min-height: auto; /* 웹에서는 자연스러운 높이 사용 */
    padding-bottom: 0;
  }
`;

interface MainLayoutProps {
  children: React.ReactNode;
  currentPage?: 'live-auctions' | 'auction' | 'home' | 'favorites' | 'mypage';
  paddingTop?: number; // 모바일에서 커스텀 상단 패딩 (px)
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, currentPage, paddingTop }) => {
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);

  // 바텀 네비게이션을 표시할 페이지들
  const showBottomNav = currentPage && ['live-auctions', 'auction', 'home', 'favorites', 'mypage'].includes(currentPage);

  const handleLoginRequired = () => {
    setShowLoginModal(true);
  };

  const handleCloseModal = () => {
    setShowLoginModal(false);
  };

  const handleLoginFromModal = () => {
    setShowLoginModal(false);
    navigate('/login');
  };

  return (
    <>
      <LayoutContainer 
        $showBottomNav={!!showBottomNav}
        $customPaddingTop={paddingTop}
      >
        {children}
      </LayoutContainer>
      
      {showBottomNav && (
        <BottomNavigation
          currentPage={currentPage}
          onLoginRequired={handleLoginRequired}
        />
      )}
      
      <LoginRequiredModal
        isOpen={showLoginModal}
        onClose={handleCloseModal}
        onLogin={handleLoginFromModal}
      />
    </>
  );
};

export default MainLayout;
